// extracted by mini-css-extract-plugin
module.exports = {"content":"u2e9rIo5MaQsjXFzyzo6","details":"aQf29cWxMsG6H1SA5Pbl","detail":"eowylzuu_oRYj88TKhTr","label":"YRz9V_6m0h4JxToWlS4d","button":"utjlnyR_nNCoggzKIaJq"};